import React from 'react';

import Header from '../../main/components/Header';
import Path from '../../path/ui/Path';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import { t } from 'i18next';

import NewDetialInfo from '../components/NewDetialInfo';
import { useSEO } from '../../../hooks/useSEO';

const Main = () => {
    useSEO({
        title: 'Жаңалықтар — Agroland.kz',
        description: 'Ауыл шаруашылығы саласындағы соңғы жаңалықтар мен оқиғалар. Аграрлық сектордағы өзгерістер, жаңа технологиялар және бастамалар.',
        keywords: 'жаңалықтар, агро жаңалықтар, ауыл шаруашылығы, технологиялар, Agroland',
        ogType: 'website'
    }, []);

    return (
        <div className="main_container">
            <Header />
            <Path currentPath={t('news')} />
            <NewDetialInfo />
            <div className="announcement_content">
                <MobileBottomBar />
            </div>
        </div>
    );
};

export default Main;